import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ImpairedInformationRoutes } from '../../modules/information/models/information-routes';
import { VersionForVisuallyImpairedRoutes } from '../../models/routes';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  public termsLink = `/visually-impaired/${VersionForVisuallyImpairedRoutes.Information}/${ImpairedInformationRoutes.TermOfUse}`;
}
